// extracted by mini-css-extract-plugin
export default {"btn":"Button__btn--xk4dAQ8fHB"};